import React from "react";
import { type FieldProps } from "react-admin";

import { useTypedFieldValue } from "@/hooks";

type GenericRecord<
  T extends Record<string, unknown> = Record<string, unknown>,
> = T;

export type TextArrayFieldProps<T extends GenericRecord> = FieldProps<T> & {
  valuesLabels?: Record<string, string>;
  children: React.ReactNode;
};

export const TextArrayField = <T extends GenericRecord>(
  props: TextArrayFieldProps<T>,
) => {
  const { valuesLabels, children, ...rest } = props;
  const value = useTypedFieldValue<string[], T>(rest) ?? [];
  const readyValues = valuesLabels
    ? value.map((item: string) => valuesLabels[item] ?? item)
    : value;

  return (
    <>
      {React.cloneElement(children as React.ReactElement, {
        data: readyValues,
      })}
    </>
  );
};
TextArrayField.defaultProps = { addLabel: true };
